export default __webpack_public_path__ + "static/media/rss.8e29d531.svg";